export default __webpack_public_path__ + "static/042-4d93fcfcdd6a87d5f503b3ebe53fc8dd.png";